import { Component} from '@angular/core';

@Component({
  selector: 'app-base-qualification-req-warning',
  templateUrl: './base-qualification-req-warning.component.html',
  standalone: false
})
export class BaseQualificationReqWarningComponent {}
